import { useNavigate } from 'react-router';

import { PageWrapper } from 'src/components/PageWrapper';
import { APP_ROUTES } from 'src/constants/routes';
import { isEmbeddedPlatform } from 'src/features/config/AppEnvironmentDetector/utils';
import { ErrorInfo } from 'src/pages/teams/_components/AuthErrorView/ErrorInfo';

import { IllustrationError500 } from '@/components/Illustration';

export const ServerError = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper darkBackground={isEmbeddedPlatform()}>
      <div className="flex flex-1 flex-col items-center justify-center gap-12">
        <ErrorInfo
          description="Please try again."
          title="Something Went Wrong"
          onClose={() => navigate(APP_ROUTES.HOME, { replace: true })}
        >
          <IllustrationError500 className="max-w-480" />
        </ErrorInfo>
      </div>
    </PageWrapper>
  );
};
